import { wizardActionTypes as ActionTypes } from '../constants';
import { fabric } from 'fabric';
import 'fabric-history';
import {makeEllipse} from '../utils/ellipse'
import {makeLine} from "../utils/line";
import {makeDottedLine} from "../utils/dottedLine";
import {makeArrow} from "../utils/arrow";
import {makeTextBox} from "../utils/textBox";
import {makeImage} from "../utils/image";
import {makeAnnotation} from "../utils/annotation";
import {measurement} from "../utils/measurementTool";
import {zoomFunction} from "../utils/zoom";
import {makeTextBoxWithBorder} from "../utils/textWithBorder";
import {makeRectangle} from "../utils/rectangle";
import {addNewImage} from "../utils/addNewImage";
import { makeDottedCurve } from 'utils/dottedCurve';
import { makeCurve } from 'utils/curve';
import { makeGroup } from 'utils/makeGroup';
import { cropImage } from  'utils/cropImage';

export default function reducer(state = {fabricInstance:Object}, action: any = {}) {
    switch (action.type) {
        case ActionTypes.INIT_FABRIC: {
            const {width, height} = action;
            const canvas = new fabric.Canvas('2DD', {  hoverCursor: 'pointer',selectable:true});
            canvas.setHeight(height);
            canvas.setWidth(width);

            //Hack to show the text-box border color after refresh
            var originalRender = fabric?.Textbox?.prototype._render;
            fabric.Textbox.prototype._render = function(ctx) {
                    originalRender.call(this, ctx);
                    ctx.save();
                    ctx.strokeStyle = this.textboxBorderColor || 'black';
                    ctx.lineWidth = 1;
                    if(this.showTextBoxBorder) {
                        ctx.strokeRect(-this.width / 2, -this.height / 2, this.width, this.height);
                    }
                    ctx.restore();
            }

            return {
                ...state,
                fabricInstance:canvas
            };
        }
        case ActionTypes.UPDATE_FABRIC: {
            const {width, height} = action;
            if(!state.fabricInstance) {
                return
            }
            const canvas:any = state.fabricInstance;
            canvas?.setHeight(height);
            canvas?.setWidth(width);

            return {
                ...state,
                fabricInstance:canvas
            };
        }
        case ActionTypes.RESET_ZOOM: {
            // @ts-ignore
            let zoom =  state.fabricInstance.getZoom();
            zoom = 1;
            // @ts-ignore
            state.fabricInstance.setZoom(zoom);
            zoomFunction(zoom)
            return {
                ...state,
                zoomValue: 1
            };
        }
       case ActionTypes.ENABLE_TOOL: {
           // @ts-ignore
           state.fabricInstance.off('mouse:down')
           // @ts-ignore
           state.fabricInstance.off('mouse:up')
           // @ts-ignore
           let zoom =  state.fabricInstance.getZoom();
           
           switch (action.toolType) {
               case ActionTypes.ELLIPSE: {
                   makeEllipse(state.fabricInstance)
                   break;
               }
                case ActionTypes.RECTANGLE: {
                   makeRectangle(state.fabricInstance, {borderColor: '#000'})
                   break;
               }
               case ActionTypes.FILLED_RECTANGLE: {
                    makeRectangle(state.fabricInstance, {borderColor: '#fff', fillColor: 'white'});
                    break;
                }
                case ActionTypes.DOTTED_RECTANGLE: {
                   makeRectangle(state.fabricInstance, {borderColor: 'var(--theme-text-color)', strokeWidth: 3})
                   break;
               }
               case ActionTypes.LINE: {
                   makeLine(state.fabricInstance,action.color)
                   break;
               }
               case ActionTypes.DOTTED_LINE: {
                   makeDottedLine(state.fabricInstance,action.color)
                   break;
               }
               case ActionTypes.CURVE: {
                    makeCurve(state.fabricInstance);
                   break;
                }
               case ActionTypes.DOTTED_CURVE: {
                   makeDottedCurve(state.fabricInstance,action.color);
                   break;
               }
               case ActionTypes.ARROW: {
                   makeArrow(state.fabricInstance)
                   break;
               }
              case ActionTypes.TEXT_BOX: {
                   makeTextBox(state.fabricInstance)
                   break;
               }
             case ActionTypes.TEXT_BOX_BORDER: {
                 makeTextBoxWithBorder(state.fabricInstance)
                   break;
               }
             case ActionTypes.IMAGE: {
                   makeImage(state.fabricInstance)
                   break;
               }
             case ActionTypes.ANNOTATION: {
                 makeAnnotation(state.fabricInstance)
                   break;
               }
             case ActionTypes.CROP_IMAGE: {
                cropImage(state.fabricInstance, state['selectedObjects'])
                break;
               }
             case ActionTypes.MEASUREMENT: {
                 measurement(state.fabricInstance)
                   break;
               }
             case ActionTypes.DISABLE_TOOL: {
                // @ts-ignore
                if(state.toolEnabled){
                  // @ts-ignore
                  state.fabricInstance.off()
                }
                 break;
               }
             case ActionTypes.ZOOM_IN: {
                 // @ts-ignore
                //  let zoom =  state.fabricInstance.getZoom();
                 zoom =zoom*1.02;
                 // @ts-ignore
                 state.fabricInstance.setZoom(zoom);
                 zoomFunction(zoom)

                 break;
               }
             case ActionTypes.ZOOM_OUT: {
                 // @ts-ignore
                //  let zoom =  state.fabricInstance.getZoom();
                 zoom =zoom/1.02;
                 // @ts-ignore
                 state.fabricInstance.setZoom(zoom);
                 zoomFunction(zoom)
                 break;
             }
             case ActionTypes.DELETE_OBJECT: {
                 // @ts-ignore
                 const activeObject =  state.fabricInstance.getActiveObject(),
                     // @ts-ignore
                     activeGroup = state.fabricInstance.getActiveObjects();
                 // @ts-ignore
                 state.fabricInstance.remove(activeObject);
                 if(activeGroup){
                     activeGroup.forEach(function(object) {
                         // @ts-ignore
                         state.fabricInstance.remove(object);
                     });
                 }
                break;
               }
               }
               return {
                ...state,
                toolEnabled: action.toolEnabled,
                zoomValue: zoom,
               };
        }
        case ActionTypes.SELECT_TOOL :{
            return {
                ...state,
                selectedTool:action.toolType
            }
        }
        case ActionTypes.OPEN_GALLERY :{
            return {
                ...state,
                isGalleryOpen:action.data
            }
                 
        }
       case ActionTypes.SET_PAGE_DETAILS :{
           return {
                ...state,
               pageDetails:action.data,

           }
        }
        case ActionTypes.EXPORT_DRAWING :{
             return {
                ...state,
                 exportDrawingStatus:'pending'
            }
        }
        case ActionTypes.EXPORT_DRAWING_SUCCESS :{
             return {
                ...state,
                 exportDrawingStatus:'success'
            }
        }
        case ActionTypes.EXPORT_DRAWING_FAIL :{
             return {
                ...state,
                 exportDrawingStatus:'fail'
            }
        }
        case ActionTypes.EXPORT_DRAWING_INPROGRESS :{
            return {
                ...state,
                exportDrawingStatus:'inprogress'
            }
        }
        case ActionTypes.REVIEW_PAGE_SUCCESS :{
            return {
                ...state,
                reviewData: action.data
            }
        }
        case ActionTypes.GET_PAGES_SUCCESS: {
            return {
                ...state,
                pages: action.data
            }
        }
        case ActionTypes.PREVIEW_DRAWING :{
             return {
                ...state,
                 previewMode:action.data
            }
        }
        case ActionTypes.PREVIEW_DRAWING_SUCCESS :{
             return {
                ...state,
                 previewMode:'disabled'
            }
        }
        case ActionTypes.PREVIEW_DRAWING_FAIL :{
             return {
                ...state,
                 previewMode:'disabled'
            }
        }
         case ActionTypes.SET_DRAWING_DATA_FAIL :{
             return {
                ...state,
                 setDrawingStatus:'failed'
            }
        }
         case ActionTypes.SET_DRAWING_DATA :{
             return {
                ...state,
                 setDrawingStatus:'pending'
            }
        }
       case ActionTypes.UPLOAD_DRAWING :{
             return {
                ...state,
                 uploadStatus:'pending'
            }
        }
         case ActionTypes.UPLOAD_DRAWING_SUCCESS :{
             return {
                ...state,
                 uploadStatus:'success'
            }
        }
         case ActionTypes.UPLOAD_DRAWING_FAIL :{
             return {
                ...state,
                 uploadStatus:'failed'
            }
        }
        case ActionTypes.GET_PROJECT_SUCCESS:{
            return {
                ...state,
                projectData: action.data
            }
        }
        case ActionTypes.GET_PROJECT_FAILURE: {
            return {
                ...state,
                error: action.data?.error
            }
        }    
        case ActionTypes.SET_DRAWING_DATA_SUCCESS :{
             return {
                ...state,
                 scaleFactor:action.data,
                 setDrawingStatus:'success'
            }
        }
        case ActionTypes.ORDER_PROFILE_TYPE: {
            return {
                ...state,
                orderProfileType:action.data
            }
        }
       case ActionTypes.SAVE_DRAWING :{
             return {
                ...state,
                 // @ts-ignore
                 drawingObject:state.fabricInstance.toJSON(),
                 screenSize:{
                     screenWidth:window.screen.width,
                     screenHeight:window.screen.height
                 }
            }
        }
        case ActionTypes.GET_ROOM_INFO_LIST :{
            return {
                ...state,
                roomInfoList: action.data
            }
        }
        case ActionTypes.SET_CUSTOMER_DETAILS: {
            return {
                ...state,
                customer_details: action.data
            }
        }
        case ActionTypes.DQC_DETAILS: {
            return {
                ...state,
                isDqcDataPresent: action.data.isDqcDataPresent,
                dqcUpdateMode:action.data.dqcUpdateMode,
                dqcAddMode:action.data.dqcAddMode
            }
        }
        case ActionTypes.SET_ROOM_NOTES: {
            return {
                ...state,
                notes: action.data
            }
        }
        case ActionTypes.SET_PROJECT_FAILURE: {
            return {
                ...state,
                error: action.data?.error
            }
        }
        case ActionTypes.SET_ROOM_NAME: {
            return {
                ...state,
                roomName: action.data
            }
        }
        case ActionTypes.PAGE_LOADING_STATUS: {
            if(action.status==='beginning'){
                return {
                    ...state,
                    pageLoadingStatus: true
                }
            }
            else if(action.status==='ending'){
                return {
                        ...state,
                        pageLoadingStatus: false
                }
            }
            break;
        }
        case ActionTypes.SET_ROOM_IMAGES: {
            return {
                ...state,
                roomImages:action.data
            }
        }
        case ActionTypes.IMAGE_DATA: {
            addNewImage(state.fabricInstance, action.data)
            return state;

        }
        case ActionTypes.TEXT_SELECTED:{
            return {
                ...state,
                isTextSelected : action.data
            }
        }
        case ActionTypes.SELECTED_OBJECT:{
            return {
                ...state,
                selectedObjects:action.data
            }
        }
        case ActionTypes.GROUPING: {
            makeGroup(state.fabricInstance, action.data);
            return state;
        }
        case ActionTypes.ENABLE_LAYERING: {
            return {
                ...state,
                layeringEnabled:action.data
            }
        }
        case ActionTypes.EXPAND_COLLAPSE_SIDEBAR_MENU: {            
            return {
                ...state,
                hideSidebar:action.data
            }
        }
        case ActionTypes.REQUIRED_META_DATA_UPDATE: {
            return {
                ...state,
                requiredMetaDataUpdate:action.data
            }
        }
        case ActionTypes.CROP_IMAGE: {
            cropImage(state.fabricInstance, state['selectedObjects'])
            return {
                ...state,
                enableCropOption:action.data
            }
        }
        case ActionTypes.SAVE_CROP_IMAGE_DETAILS: {
            return {
                ...state,
                selectedCropImageDetails:action.data
            }
        }
        case ActionTypes.SHOW_CREATION_TABLE_MODAL: {
            return {
                ...state,
                showTableCreationModal:action.data
            }
        }
        case ActionTypes.PAINT_FORMATTING_ENABLE: {
            return {
                ...state,
                paintFormatting:action.data
            }
        }
        case ActionTypes.UPLOADING_IMAGES: {
            return {
                ...state,
                uploadingImage:action.data
            }
        }
        case ActionTypes.ORDER_PROFILE_TITTLE: {
            return {
                ...state,
                orderProfileTitle:action.data
            }
        }
        default:
            return state;

    }

}